/**
 * Theme API — đọc/ghi theme global trên backend.
 * Nếu API lỗi, caller phải fallback localStorage (xem themeApply.ts).
 */
import { api } from "@/lib/api";
import type { CustomMap } from "./themeConstants";

export type ThemePayload = { preset: string; custom: CustomMap };

export async function fetchTheme(): Promise<ThemePayload | null> {
  try {
    const r = await api.get<{ preset: string; custom: Record<string, string> }>("/theme");
    return {
      preset: typeof r.preset === "string" ? r.preset : "",
      custom: (r.custom ?? {}) as CustomMap,
    };
  } catch {
    return null;
  }
}

export async function saveTheme(payload: ThemePayload): Promise<boolean> {
  try {
    await api.put("/theme", payload);
    return true;
  } catch {
    return false;
  }
}
